import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './ResponsiveMenuStyles.css';

const menuItems = [
    { label: 'Grip Series', category: 'grip series' },
    { label: 'Grip Accessories', category: 'grip accessories' },
    { label: 'Eko Series', category: 'eko series' },
    { label: 'X Series', category: 'x series' },
];

const sizeLinks = [
    { label: 'Small Cases', size: 'small' },
    { label: 'Medium Cases', size: 'medium' },
    { label: 'Big Cases', size: 'big' },
    { label: 'Long Cases', size: 'long' },
];

const ResponsiveMenu = ({ isOpen = false, onClose = () => {} }) => {
    const [isDepartmentsOpen, setIsDepartmentsOpen] = useState(false);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const menuRef = useRef(null);
    const dropdownRef = useRef(null);
    const navigate = useNavigate();

    const toggleDepartments = () => {
        setIsDepartmentsOpen(!isDepartmentsOpen);
    };

    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };

    const categoryPath = (category) => `/category/${encodeURIComponent(category.trim().toLowerCase())}`;

    const handleCategoryClick = (category) => {
        setIsDepartmentsOpen(false);
        navigate(categoryPath(category));
        onClose(); // Close mobile menu after navigation
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsDepartmentsOpen(false);
            }
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    // Reset dropdowns when mobile menu closes
    useEffect(() => {
        if (!isOpen) {
            setIsDepartmentsOpen(false);
            setIsDropdownOpen(false);
        }
    }, [isOpen]);

    // Close mobile menu when clicking overlay
    const handleOverlayClick = (e) => {
        if (e.target.classList.contains('navbar') && isOpen) {
            onClose();
        }
    };

    return (
        <nav className={`navbar ${isOpen ? 'mobile-menu-open' : ''}`} onClick={handleOverlayClick}>
            <div className="navbar-container">
                {/* All Departments Dropdown */}
                <div className="departments-dropdown" ref={menuRef}>
                    <button
                        onClick={toggleDepartments}
                        className="departments-button"
                        aria-label="All Departments"
                    >
                        <i className="fa fa-th-large"></i>
                        Categories
                        <i className={`fa fa-chevron-${isDepartmentsOpen ? 'up' : 'down'}`}></i>
                    </button>

                    {isDepartmentsOpen && (
                        <div className="departments-menu">
                            <ul className="departments-list">
                                {menuItems.map((item, index) => (
                                    <li key={index} onClick={() => handleCategoryClick(item.category)}>
                                        {item.label}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                </div>

                {/* Navigation Links */}
                <div className="navbar-links">
                    <Link to="/" className="nav-link" onClick={onClose}>Home</Link>
                    {sizeLinks.map((item) => (
                        <Link key={item.size} to={`/size/${item.size}`} className="nav-link" onClick={onClose}>{item.label}</Link>
                    ))}
                    <Link to="/trolly" className="nav-link" onClick={onClose}>Trolley</Link>                </div>
            </div>
        </nav>
    );
};

export default ResponsiveMenu;
